//import logo from './logo.svg';
import "./App.css";
// import NotificationPrompt from "./components/NotificationPrompt";
import NotificationProvider from "./context/NotificationProvider";
import { ThemeProvider } from "./context/ThemeContext";
import Root from "./routes/Root";
import "./styles/globals.css";
import "@ant-design/v5-patch-for-react-19";
import { useAutoLogout } from "./hooks/useAutoLogout";

function App() {
  // Auto-logout timer based on user's security settings
  useAutoLogout();

  return (
    <ThemeProvider>
      <NotificationProvider>
        {/*<NotificationPrompt>*/}
        <Root />
        {/*</NotificationPrompt>*/}
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
